import { render } from "./ProfileStudent.vue?vue&type=template&id=5363d95a&scoped=true"
import script from "./ProfileStudent.vue?vue&type=script&lang=js"
export * from "./ProfileStudent.vue?vue&type=script&lang=js"

import "./ProfileStudent.vue?vue&type=style&index=0&id=5363d95a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5363d95a"]])

export default __exports__